/*import { createBreakpoints } from "@chakra-ui/theme-tools";

export const breakpoints = createBreakpoints({
  sm: "320px",
  "2sm": "380px",
  md: "768px",
  lg: "1500px",
  xl: "1900px",
  "2xl": "1920px",
  "3xl": "2500px",
});*/

export const breakpoints = {
  sm: "320px",
  "2sm": "380px",
  md: "768px",
  lg: "1500px",
  xl: "1900px",
  "2xl": "1920px",
  "3xl": "2500px",
};

{/*
export const breakpoints = createBreakpoints({
  sm: "320px",
  "2sm": "380px",
  md: "768px",
  lg: "960px",
  xl: "1200px",
  "2xl": "1600px",
  "3xl": "1920px",
});
export const breakpoints = createBreakpoints({
  sm: "320px",
  "2sm": "380px",
  md: "768px",
  lg: "1500px",
  xl: "1900px",
  "2xl": "1920px",
  "3xl": "2500px",
});*/}
